import React, { useState, useEffect } from "react";
import { Button, InputAdornment, IconButton, Modal, Container, Stack, TextField, Box, Autocomplete } from "@mui/material";

import _ from 'lodash';
import dayjs from "dayjs";
import { Search } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import TimeIcon from "@mui/icons-material/AccessTime";
import AttachmentIcon from "@mui/icons-material/Attachment";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import config from "../../../../hoa-config";
import CustomDateField from "../../../../Container/custom-date-field";
import SourceIDVerificationCard from "../common/SourceIDVerificationCard";
import PDFsContainerComponent from "../../../pdf-container-component/hoa-pool-access-form-pdf-container";

const filteredAmenityOptions = Object.keys(config.amenityIcons).filter((item) => item !== "Beache Access");

const AddAmenityEvent = ({
	open,
	onClose,
	view,
	state,
	setState,
	setAmenities,
	toBeEditedEvent,
	setToBeEditedEvent,
	setDocumentName,
	setSelectedDocument,
	toggleOpen,
	deleteOpen,
	event,
	setEvent,
	amenityTags,
	setAmenityTags,
	checkNewAmenitiesWarning,
}: any) => {
	const [checkError, setCheckError] = useState(false);
	const [selectedTag, setSelectedTag] = useState("");
	const [sourceFileInfo, setSourceFileInfo] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (toBeEditedEvent) {
			setEvent(toBeEditedEvent);
		}
	}, [toBeEditedEvent]);

	const handleChange = (value: any, key: string) => {
		setEvent({ ...event, [key]: value });
	};

	const onSaveClick = () => {
		setCheckError(true);
		if (!event.title || !event.address) return;
		let tempState = JSON.parse(JSON.stringify(state));
		// let index = tempState.amenityEvents.indexOf(toBeEditedEvent);
		let index = tempState.amenityEvents.findIndex((event: any) =>
			_.isEqual(event, toBeEditedEvent)
		);

		if (index >= 0) {
			tempState.amenityEvents[index] = event;
		} else {
			tempState.amenityEvents.push(event);
		}
		checkNewAmenitiesWarning(tempState.newAvailableAmenities, tempState.accessInformation, tempState.amenityEvents);
		setState(tempState);
		setAmenities([...tempState.amenityEvents]);
		setEvent({});
		setToBeEditedEvent({});
		setCheckError(false);
		onClose();
	};

	const deleteClick = (document: string, name: any) => {
		setDocumentName(document);
		setSelectedDocument(name);
		toggleOpen(!deleteOpen);
	};
	const handleClose = () => {
		setSelectedTag("");
		setCheckError(false);
		setToBeEditedEvent({});
		onClose();
	};

	let selectedFiles = event.newsLetterNotificationFiles && event.newsLetterNotificationFiles.filter((file: any) => file.name);
	let uploadedFiles = event.newsLetterNotificationFiles && event.newsLetterNotificationFiles.filter((file: any) => file.fileName);

	const tagOptionReset = (value: any) => {
		const newOptions = amenityTags.filter((option: string) => {
			return !value.includes(option);
		});
		setAmenityTags(newOptions);
	};

	const handleTagChange = (value: any, key: string) => {
		let tempState: any = { ...event };
		if (key === "selectedTag" && value) {
			if (tempState.amenityTags) {
				tempState.amenityTags.push(value);
			} else {
				tempState.amenityTags = [];
				tempState.amenityTags.push(value);
			}
			tagOptionReset(tempState.amenityTags);
			setEvent(tempState);
			setSelectedTag("");
			return;
		}
	};

	const removeTag = (tag: string) => {
		let tempState: any = { ...event };
		tempState.amenityTags = tempState.amenityTags.filter((currentTag: string) => {
			return currentTag !== tag;
		});
		setAmenityTags([...amenityTags, tag]);
		setEvent(tempState);
	};

	useEffect(() => {
		setAmenityTags(filteredAmenityOptions);
		if (event.amenityTags) {
			const newOptions = amenityTags.filter((option: string) => {
				return event.amenityTags && !event.amenityTags.includes(option);
			});
			setAmenityTags(newOptions);
		}
		if (event.newsLetterNotificationFiles) {
			setSourceFileInfo(event.newsLetterNotificationFiles || []);
		}
	}, [event]);

	const addNewSourceDocument = () => {
		const newSource = {
			isVerified: false,
			sourceId: "",
			sourceIdType: "",
		};
		setSourceFileInfo([newSource, ...sourceFileInfo]);
	};

	const deleteSourceDocument = (index: number) => {
		let tempState = [...sourceFileInfo];
		tempState = tempState.filter((item, idx) => idx !== index);
		setSourceFileInfo(tempState);
		setEvent({ ...event, newsLetterNotificationFiles: tempState });
	};

	const handleSourceFile = (e: any, index: number) => {
		const { name, value } = e.target;
		const tempState = [...sourceFileInfo];
		tempState[index][name] = value;
		if (name === "files" && value.length > 0) {
			tempState[index]["isVerified"] = true;
		} else if (name === "files" && value.length == 0) {
			tempState[index]["isVerified"] = false;
		}
		setSourceFileInfo(tempState);
		setEvent({ ...event, newsLetterNotificationFiles: tempState });
	};

	const isAllVerified = sourceFileInfo.every((item: any) => item.isVerified || item.url);

	return (
		<Modal open={open} onClose={handleClose}>
			<Container className="modal-container-style-amenity2" disableGutters>
				<div className="modal-wrapper-amenity">
					<Stack
						direction={"row"}
						position={"sticky"}
						zIndex={9999999}
						top={0}
						sx={{ background: "#EFF4FC" }}
						justifyContent={"space-between"}
						alignItems={"center"}
						pl={"24px"}
						pr={"24px"}
						height={72}
						borderBottom={"1px solid #E8E8E8"}
					>
						<Box display={"flex"} alignItems={"center"}>
							<p
								style={{
									color: "#3E3E3E",
									fontSize: "20px",
									fontWeight: "500",
									fontFamily: "roboto",
								}}
							>
								{Object.keys(toBeEditedEvent).length ? `Update Event` : `Add Event`}
							</p>
						</Box>
						<Box>
							<IconButton onClick={handleClose}>
								<CloseOutlinedIcon sx={{ color: "#2F2F2F" }} />
							</IconButton>
						</Box>
					</Stack>
					<Stack style={{ padding: "6px 24px 0 24px" }}>
						<Stack>
							<div
								style={{
									display: "flex",
									marginTop: "24px",
									justifyContent: "space-between",
								}}
							>
								<TextField
									style={{ width: "100%" }}
									variant="standard"
									label="Title"
									name="title"
									value={event.title || ""}
									required
									onChange={(e) => {
										handleChange(e.target.value, "title");
									}}
									InputLabelProps={{ style: { fontSize: "14px" } }}
									error={checkError && !state.title}
									InputProps={{ style: { padding: "7px 0px" } }}
								/>
							</div>
							<div style={{ marginTop: "24px" }}>
								<TextField
									style={{ width: "100%" }}
									variant="standard"
									label="Address"
									name="address"
									value={event.address || ""}
									required
									onChange={(e) => {
										handleChange(e.target.value, "address");
									}}
									InputLabelProps={{ style: { fontSize: "14px" } }}
									error={checkError && !state.address}
									InputProps={{ style: { padding: "7px 0px" } }}
								/>
							</div>
							<div style={{ marginTop: "24px" }}>
								<TextField
									style={{ width: "100%" }}
									variant="standard"
									label="Additional Information"
									name="additionalInformation"
									value={event.additionalInformation || ""}
									required
									onChange={(e) => {
										handleChange(e.target.value, "additionalInformation");
									}}
									InputLabelProps={{ style: { fontSize: "14px" } }}
									error={checkError && !state.additionalInformation}
									InputProps={{ style: { padding: "7px 0px" } }}
								/>
							</div>

							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									paddingBottom: "24px",
									borderBottom: "1px solid #E8E8E8",
								}}
							>
								<CustomDateField
									label="Start Date"
									error={false}
									variant="standard"
									style={{ width: "45%", padding: "10px 0px", marginTop: "24px" }}
									value={dayjs(event.eventDate || null)}
									handleChange={(value: any) => {
										handleChange(value, "eventDate");
									}}
								/>
								<CustomDateField
									label="End Date"
									error={false}
									variant="standard"
									style={{ width: "45%", padding: "10px 0px", marginTop: "24px" }}
									value={dayjs(event.endDate || null)}
									handleChange={(value: any) => {
										handleChange(value, "endDate");
									}}
								/>
							</div>

							<div className="sub-title-text-2" style={{ margin: "12px 0px" }}>
								Time
							</div>
							<div
								style={{
									display: "flex",
									paddingBottom: "24px",
									borderBottom: "1px solid #E8E8E8",
								}}
							>
								<TextField
									style={{ width: "35%", marginRight: "24px" }}
									variant="standard"
									type="time"
									label="From"
									name="fromTime"
									value={event?.fromTime || ""}
									onChange={(e) => {
										handleChange(e.target.value, "fromTime");
									}}
									InputLabelProps={{
										style: { fontSize: "14px", transform: "translateY(7px)" },
									}}
									InputProps={{
										style: { padding: "7px 0px" },
										endAdornment: (
											<InputAdornment position="end">
												<TimeIcon />
											</InputAdornment>
										),
									}}
								/>
								<TextField
									style={{ width: "35%" }}
									variant="standard"
									type="time"
									label="To"
									name="toTime"
									value={event?.toTime || ""}
									onChange={(e) => {
										handleChange(e.target.value, "toTime");
									}}
									InputLabelProps={{
										style: { fontSize: "14px", transform: "translateY(7px)" },
									}}
									InputProps={{
										style: { padding: "7px 0px" },
										endAdornment: (
											<InputAdornment position="end">
												<TimeIcon />
											</InputAdornment>
										),
									}}
								/>
							</div>
							<Stack>
								<div className="sub-title-text-2" style={{ margin: "24px 0px" }}>
									Newsletter & Notification
								</div>
								{uploadedFiles?.length > 0 ? (
									<>
										<p className="helperText" style={{ fontWeight: "bold" }}>
											Uploaded File :
										</p>
										{Array.from(uploadedFiles).map((file: any, index: number) => {
											if (file?.fileName) {
												return <PDFsContainerComponent document={`newsLetterNotificationFiles`} deleteClick={deleteClick} view={view} key={index} file={file} />;
											}
										})}
									</>
								) : (
									""
								)}
							</Stack>
							<Stack direction={"row"} alignItems="center" spacing={2} paddingTop="10px">
								<Button startIcon={<AttachmentIcon color="primary" />} variant="outlined" disabled={!isAllVerified} onClick={addNewSourceDocument}>
									Attach Document
								</Button>
							</Stack>
							<Stack>
								{sourceFileInfo
									.filter((sourceFile: any) => !sourceFile.url)
									.map((item: any, index: any) => (
										<SourceIDVerificationCard
											key={index}
											index={index}
											parentIndex={index}
											item={item}
											loading={loading}
											setLoading={setLoading}
											handleSourceFile={handleSourceFile}
											handleDeleteCard={deleteSourceDocument}
										/>
									))}
							</Stack>

							<div style={{ paddingBottom: "10px" }}>
								<div className="sub-title-text-2" style={{ margin: "12px 0px" }}>
									{" "}
									Select Amenities
								</div>
								<Autocomplete
									ListboxProps={{ style: { maxHeight: "200px" } }}
									style={{
										width: "80%",
										height: "62px",
										boxSizing: "border-box",
									}}
									disablePortal
									value={selectedTag || ""}
									options={amenityTags}
									onChange={(e, v) => {
										handleTagChange(v, "selectedTag");
									}}
									renderInput={(params: any) => (
										<TextField
											variant="standard"
											style={{ height: "100%" }}
											{...{
												...params,
												InputProps: {
													...params.InputProps,
													style: { height: "100%" },
												},
											}}
											InputProps={{
												...params.InputProps,
												style: {
													height: "62px",
												},
												startAdornment: (
													<>
														<InputAdornment position="start">
															<Search style={{ color: "#787878" }} />
														</InputAdornment>
													</>
												),
											}}
											placeholder="Write name here to add"
										/>
									)}
								/>
								<div
									style={{
										marginTop: "24px",
										display: "flex",
										flexDirection: "row",
										flexWrap: "wrap",
									}}
								>
									{event.amenityTags &&
										event.amenityTags.map((tag: string, index: number) => {
											return (
												<div className="amenityIconBox" key={index}>
													{React.createElement(config.amenityIcons[tag], {
														color: "primary",
													})}
													<span style={{ margin: "0px 5px" }}>{tag}</span>
													<IconButton
														onClick={() => {
															removeTag(tag);
														}}
														style={{ padding: "0px" }}
													>
														<CloseIcon />
													</IconButton>
												</div>
											);
										})}
								</div>
							</div>
						</Stack>
					</Stack>
					<Stack style={{ padding: "24px", border: "1px solid #E8E8E8" }} direction={"row"} spacing={1} justifyContent="flex-end">
						<>
							<Button
								onClick={() => {
									onClose();
									setCheckError(false);
									setToBeEditedEvent({});
								}}
								variant="outlined"
							>
								Cancel
							</Button>
							<Button onClick={onSaveClick} variant="contained" style={{ color: "#fff", backgroundColor: "#3576E5" }}>
								Save
							</Button>
						</>
					</Stack>
				</div>
			</Container>
		</Modal>
	);
};

export default AddAmenityEvent;
